import { AuthService } from './../../services/auth.service';
import { IntervinientesService } from './../../services/intervinientes.service';
import { Location } from '@angular/common';
import { ClientesPymesService } from './../../services/clientes-pymes.service';
import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-laboral-doc',
  templateUrl: './laboral-doc.component.html',
  styleUrls: ['./laboral-doc.component.css']
})
export class LaboralDocComponent implements OnInit {

  @ViewChild("archivoSubido") archivoSubido:ElementRef;
  @ViewChild("mensaje") mensaje:ElementRef;
  tiposdoc=[];
  documento={};
  codigo;


  constructor(private clientesPymesService:ClientesPymesService, private activatedRoute:ActivatedRoute,
              private location:Location, private intervinientesService:IntervinientesService,
              private auth:AuthService, private router:Router, private renderer:Renderer2) {
    
    this.cargarTiposDoc();
    this.intervinientesService.getNombresIntervinientes().subscribe();
    this.activatedRoute.params
    .subscribe(params=>{
      this.codigo=params["cod"];
      if(this.codigo=="nuevo"){
        
        if(!this.clientesPymesService.categoriaActual){
          this.location.back();
        }
        this.documento["PDcodtipo_doc"]=this.activatedRoute.snapshot.queryParams.tipo;
      }else{
        this.cargarDocumento(this.codigo);
      }
    });
  }

  ngOnInit() {
  }


  cargarDocumento(iddoc){
    this.clientesPymesService.cargarDocumento(iddoc)
    .subscribe(resp=>{
      if(resp["err"]==true){
        this.router.navigate(['/home']);
        return false;
      }else{
        this.documento=resp["documento"];
      }
    });

    
  }

  cargarTiposDoc(){
    this.clientesPymesService.cargarTiposDoc('L')
    .subscribe(resp=>{
      
      this.tiposdoc=resp;
    });
  }

  guardarDoc(myform:NgForm){
    if(myform.valid){
      if(this.codigo=='nuevo'){
        this.insertarDoc();
      }else{
        this.actualizarDoc();
      }
    }
  }

  insertarDoc(){
    this.clientesPymesService.insertDoc(this.documento,  this.archivoSubido.nativeElement.files[0])
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["msg"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);

      if(resp["err"]==true){
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "green");
      }

      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
        this.location.back();
      }, 1500);
    })
  }

  actualizarDoc(){
    this.clientesPymesService.updateDoc(this.documento)
    .subscribe(resp=>{
      
      let texto=this.renderer.createText(resp["msg"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);

      if(resp["err"]==true){
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "green");
      }

      setTimeout(() => {
        this.renderer.removeChild(this.mensaje.nativeElement, texto);
        this.location.back();
      }, 1500);
    });
  }

  volver(){
    this.location.back();
  }

  parseDate(dateString: string){
    if (dateString) {
      let fecha=new Date(dateString);
      var myDate_string = fecha.toISOString();
      var myDate_string = myDate_string.replace("T"," ");
      var myDate_string = myDate_string.substring(0,10);
        return myDate_string;
    } else {
        return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/laboral-doc/laboral-doc.component.ts